<template>
  <div>
    <van-nav-bar style="background-color: #42b983">
      <template #title>
        <span style="color: #ffffff">学员充值情况</span>
      </template>
      <template #left>
        <router-link to="/my">
          <van-icon name="arrow-left" color="#ffffff"/>
          <span style="color: #ffffff">返回</span>
        </router-link>
      </template>
      <template #right>
        <router-link to="/">
          <van-icon name="wap-home-o" color="#ffffff" size="1.3rem"/>
        </router-link>
      </template>
    </van-nav-bar>

    <van-tabs v-model="tabActive" @click="onLoad(true)">
      <van-tab title="今日" name="today"/>
      <van-tab title="昨天" name="yesterday"/>
      <van-tab title="本周" name="this_week"/>
      <van-tab title="本月" name="this_month"/>
      <van-tab title="上月" name="last_month"/>
    </van-tabs>
    <!--        <van-search v-model="searchValue" @search="onLoad(true)" placeholder="请输入搜索关键词"/>-->


    <!--        <van-divider :style="{margin: '6px 0' }">为你搜索到{{listTotal}}笔订单</van-divider>-->


    <van-row style="line-height: 50px;margin: 0 16px;">
      <van-col>
        总额:{{ all_amount_total }}元 &nbsp; {{ all_order_num }}笔
        &nbsp;
        代理:{{ organ_amount_total }}元&nbsp; {{ organ_order_num }}笔

      </van-col>
      <van-col>
        <van-button type="default" size="small" @click="changeSearchModel = true">查找</van-button>&nbsp;&nbsp;
      </van-col>
    </van-row>

    <van-list
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        :error-text="error_text"
        finished-text="没有更多了"
        @load="onLoad(false)"
    >
      <van-collapse v-model="listActive">

        <van-panel
            v-for="order in orders" :key="order.id"
            :title="order.user.nickname+'(ID:'+order.user.id+')'"
            :desc="'代理机构ID:'+order.user.organ_id"
        >
          <div style="font-weight: 100;padding-left: 16px">
            充值项:{{ order.product.title }}<br>
            充值时间:{{ order.pay_time }}<br>
            充值金额:{{ order.total_amount }}元<br>
            充值科目:{{ order.subject.name }}
          </div>
        </van-panel>


      </van-collapse>
    </van-list>

    <van-dialog v-model="changeSearchModel"
                showCancelButton
                @confirm="onLoad(true)"
                title="用户查找">
      <van-row style="margin: 10px 20px">
        <van-search v-model="user_id" placeholder="请输入用户id"/>
      </van-row>
    </van-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      tabActive: "this_week",
      is_organ: 0,
      page: 1,
      listTotal: 0,
      listActive: [],

      changeSearchModel: false,

      loading: false,
      finished: false,
      error: false,
      error_text: "",
      searchValue: "",
      user_id: "",

      orders: [],

      all_amount_total: 0,
      all_order_num: 0,
      organ_amount_total: 0,
      organ_order_num: 0,
    };
  },
  created() {
    if (undefined === this.$route.query.is_organ || "" === this.$route.query.is_organ) {
      this.is_organ = 0
    } else {
      this.is_organ = 1
    }
  },
  methods: {
    onLoad(isNew) {
      if (isNew) {
        this.orders = [];
        this.page = 1;
        this.finished = false;
      }
      this.loading = true;
      this.$http.get("/wechat/organ/orders", {
        params: {
          pre_page: 8,
          is_organ: this.is_organ,
          page: this.page,
          special: this.tabActive,
          word: this.searchValue,
          user_id: this.user_id,
        }
      }).then(res => {
        this.loading = false;
        console.log(res.data);
        if (200 !== res.data.code) {
          this.error = true
          this.error_text = res.data.msg
          return
        }
        if (!res.data.data || res.data.data.length <= 0 || res.data.data.orders.length <= 0) {
          this.finished = true
          return;
        }
        this.page++


        this.all_amount_total = res.data.data.all_amount_total;
        this.all_order_num = res.data.data.all_order_num;
        this.organ_amount_total = res.data.data.organ_amount_total;
        this.organ_order_num = res.data.data.organ_order_num;

        this.listTotal = res.data.meta.total
        this.orders = this.orders.concat(res.data.data.orders);
      });
    }
  }
}
</script>
